import { YahooAd } from '@components/buzzkuri/shared/script/yahoo'
import { NextSeo } from 'next-seo'
import Head from 'next/head'
import { FC } from 'react'
import { OpenGraph, OpenGraphMedia } from 'next-seo/lib/types'
import { cloudfrontPath } from '@utils/image'

export const BusinessHead: FC<{
  title?: string
  description?: string
  openGraph?: OpenGraph
  // セキュリティに関係するので明示指定必須にします
  noindex: boolean
  nofollow?: boolean
}> = ({ noindex, title, description, openGraph, nofollow = noindex }) => {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <YahooAd />
      </Head>
      <NextSeo
        noindex={noindex}
        nofollow={nofollow}
        title={title}
        description={description}
        titleTemplate="%s | バヅクリ | エンゲージメントサーベイと研修・イベントで組織改善"
        defaultTitle="バヅクリ | エンゲージメントサーベイと研修・イベントで組織改善"
        openGraph={
          openGraph
            ? {
                site_name: 'バヅクリ',
                type: 'website',
                ...openGraph,
              }
            : undefined
        }
      />
    </>
  )
}

export const OG_DEFAULT_IMAGE: OpenGraphMedia = {
  url: `${cloudfrontPath}/home/img/logo.jpg`,
  width: 1000,
  height: 680,
}
